import { render, staticRenderFns } from "./MoreSources.vue?vue&type=template&id=477de017&scoped=true"
import script from "./MoreSources.vue?vue&type=script&lang=js"
export * from "./MoreSources.vue?vue&type=script&lang=js"
import style0 from "./MoreSources.vue?vue&type=style&index=0&id=477de017&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477de017",
  null
  
)

export default component.exports